import { ItemTypeInterface } from "../interface/TypeInterface"

export const ItemTypeInit : ItemTypeInterface = {
    codeTypeId : 0,
    codeTypeName : "",
    deleteFlag : "",
    menuId : 1,
    crmTableName : "",
}